module.exports = __webpack_public_path__ + "img/bg right.63ad80e9.png";